import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from '../../../../../app/hooks'
import { fetchDestinations } from '../../../../../features/subway/subwayThunk'
import { generateActions } from '../../../../../shared/utils'
import { ActionType } from '../../../../Actions/types'

const useSubwayContent = () => {
  const dispatch = useDispatch()

  const { destinations, loading, error } = useAppSelector(
    (state) => state.subway
  )
  const { active } = useAppSelector((state) => state.poi)
  const {
    data: activePOIData,
    loading: activePOILoading,
    error: activePOIError,
  } = active
  const activePOISceneId = activePOIData?.scene?.id

  useEffect(() => {
    if (activePOISceneId) {
      dispatch(
        fetchDestinations({
          sceneId: activePOISceneId,
        })
      )
    }
  }, [dispatch, activePOISceneId])

  console.log('destinations', destinations)

  const actions = useMemo(() => {
    if (!destinations?.length) return []
    // convert each destination to a partial scene for use with generating actions
    const destinationScenes = destinations.map((destination) => ({
      id: destination.id,
      action:
        `${destination?.neighborhood}: ${destination?.name}` || destination.id,
      type: ActionType.SCENE,
    }))
    return generateActions({ scenes: destinationScenes })
  }, [destinations])

  return {
    destinations,
    loading: loading || activePOILoading,
    error: error || activePOIError,
    actions,
  }
}

export default useSubwayContent
